import angular from 'angular';
import touch from 'angular-touch';

import TestimonialComponent from './testimonial.cmpt';

export default angular
    .module('presentation.component.testimonial', [
        touch
    ])
    .component(TestimonialComponent.selector, TestimonialComponent);



// WEBPACK FOOTER //
// ./src/presentation/component/testimonial/index.js